import { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { withLogin } from 'Components/hocs';
import ImageCheckbox from 'Components/ImageCheckbox';
import ProgressBar from 'Components/ProgressBar';
import {
  filterInterests,
  programmingInterests,
  setOptout,
  saveInterestsArray,
} from 'Services/interests';
import * as analytics from 'Utils/analytics';

const { EVENTS } = analytics;

const SetInterests = ({ redirect, strings, uim }) => {
  const [selections, setSelections] = useState([]);
  const [submitting, setSubmitting] = useState(false);
  const [valid, setValid] = useState(false);

  const getUser = async () => {
    const userToken = await uim.getJWT();
    const { siloUserId: userId } = uim.getAuthenticatedUser();
    return {
      userId,
      userToken,
    };
  };

  const select = (item) => {
    let items = [...selections];
    items.push(item);
    setSelections(items);
  };

  const remove = (item) => {
    const items = selections.filter((selections) => selections !== item);
    setSelections(items);
  };

  const isValid = () => {
    if (selections.length >= 3) {
      setValid(true);
    } else {
      setValid(false);
    }
  };

  useEffect(isValid, [selections]);

  const handleChange = (event) => {
    if (event.target.checked) {
      select(event.target.value);
    } else {
      remove(event.target.value);
    }
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    for (const selection of selections) {
      analytics.event({
        action: EVENTS.selectInterestOnboardItem,
        label: selection,
      });
    }
    setSubmitting(true);
    const { userId, userToken } = await getUser();
    const saved = await saveInterestsArray(selections, userId, userToken);
    if (saved) {
      redirect();
    }
  };

  const optout = async (event) => {
    event.preventDefault();
    analytics.event({ action: EVENTS.skip, label: 'skipInterests' });
    setSubmitting(true);
    const { userId, userToken } = await getUser();
    const optout = await setOptout(true, userId, userToken);
    if (optout) {
      redirect();
    }
  };

  useEffect(() => getUser, []);

  return (
    <div>
      {submitting && <ProgressBar />}
      <h1 className="page-heading">{strings.interestsHeading}</h1>
      <h2 className="page-subheading">{strings.interestsSubheading}</h2>
      <form className="selection__form" onSubmit={handleSubmit}>
        <div className="selections">
          {programmingInterests.map((interest) => (
            <ImageCheckbox
              image={`https://account.redbull.com/bundles/assets/static/img/${interest}.jpg`}
              key={interest}
              onChange={handleChange}
              text={filterInterests('programming')[interest].name}
              value={interest}
            />
          ))}
        </div>
        <button
          className="selection__button"
          type="submit"
          disabled={!valid || submitting}
        >
          {strings.continue}
        </button>
      </form>
      <div className="sublink" onClick={optout}>
        {strings.skip}
      </div>
    </div>
  );
};

SetInterests.propTypes = {
  redirect: PropTypes.func.isRequired,
  strings: PropTypes.object.isRequired,
  uim: PropTypes.object.isRequired,
};

export default withLogin(SetInterests);
